import { slug, removeAccents } from './slugUtil';

export const decodeText = (text) => {
  if (text) {
    const decode64Text = atob(text);
    const decodeByte = new TextDecoder('utf-8').decode(Uint8Array.from(decode64Text, (m) => m.codePointAt(0)));
    return removeAccents(decodeByte);
  }
  return '';
};

export const processLocation = (value) => ({
  country: slug(value ? value[0] : ''),
  state: slug(value ? value[1] : ''),
  city: value ? value[2] : '',
});

export function getLocationByCookie(nameCookie = 'x-ctbz-geolocation') {
  let valueCookie = [''];
  const cookieRegExp = new RegExp(`${nameCookie}=([^;]+)`);
  const recoveredCookie = cookieRegExp.exec(document.cookie);

  if (recoveredCookie) {
    valueCookie = decodeText(recoveredCookie[1]).split('_');
  }
  return processLocation(valueCookie);
}

export function getLocationByHeader(nameHeader = 'x-ctbz-geolocation') {
  return new Promise((resolve, reject) => {
    const req = new XMLHttpRequest();

    const timeoutId = setTimeout(() => {
      req.abort();
      reject(new Error('Request timed out'));
    }, 3000);

    req.open('GET', document.location.toString(), true);
    req.send(null);
    req.onload = function() {
      clearTimeout(timeoutId);
      const headers = req.getAllResponseHeaders()
        .trim()
        .split(/[\r\n]+/)
        .map((value) => value.split(/: /))
        .reduce((acc, [key, value]) => {
          acc[key.trim()] = value.trim();
          return acc;
        }, {});

      const valueHeader = decodeText(headers[nameHeader]).split('_');
      req.abort();
      resolve(processLocation(valueHeader));
    };

    req.onerror = function() {
      clearTimeout(timeoutId);
      reject(new Error('Error fetching location'));
    };
  });
}

export const getLocationByAzion = () => {
  const resultCookie = getLocationByCookie();
  const resultCookieIsValid = !!(resultCookie.city && resultCookie.state && resultCookie.country);

  if (resultCookieIsValid) {
    return Promise.resolve(resultCookie);
  }

  return getLocationByHeader()
    .then((result) => result)
    .catch(() => false);
};
